import {
	EmissionsActivityResultsDTO,
	EmissionsIntervalResultsDTO,
	EmissionsResultsDTO,
	EmissionsScopeResultsDTO,
	ResultsBasePayload,
} from "../../../datasources/api-client/data-contracts";
import { ApiRoutes } from "../../../datasources/networking/apiRoutes";
import { useReadResource } from "../../../hooks/useResource";
import { TransportPerspective } from "../../../state/preferences";

interface Options {
	payload: ResultsBasePayload;
	perspective: TransportPerspective;
	periodType: "month" | "quarter" | "four-month" | "semester";
}

/**
 * useOverviewData loads all the data shown in the results overview page.
 */
export function useOverviewData({ payload, perspective, periodType }: Options) {
	const emissions = useReadResource<ResultsBasePayload, EmissionsResultsDTO>(
		{ route: ApiRoutes.ResultsEmissions, query: { perspective } },
		{ readMethod: "post" },
		payload
	);

	const intervals = useReadResource<ResultsBasePayload, EmissionsIntervalResultsDTO>(
		{ route: ApiRoutes.ResultsEmissionsIntervals, query: { perspective } },
		{ readMethod: "post" },
		{ ...payload, period: periodType }
	);

	const scopeEmissions = useReadResource<ResultsBasePayload, EmissionsScopeResultsDTO>(
		{ route: ApiRoutes.ResultsScopeEmissions, query: { perspective } },
		{ readMethod: "post" },
		payload
	);

	const activityEmissions = useReadResource<ResultsBasePayload, EmissionsActivityResultsDTO>(
		{ route: ApiRoutes.ResultsActivityEmissions, query: { perspective } },
		{ readMethod: "post" },
		payload
	);

	return {
		emissions,
		intervals,
		scopeEmissions,
		activityEmissions,
	};
}
